let accountId=null,enabled=false,context=null,buffer=null,loading=null;
let initialized=false,latestIncoming=0;
const listeners=new Set();
let busy=false,error=false;
const key=id=>'aeonas-chat-sound:'+id;
function emit(){listeners.forEach(fn=>fn());}
export function soundState(){return{enabled,ready:Boolean(context?.state==='running'&&buffer),busy,error};}
export function subscribeSound(fn){listeners.add(fn);return()=>listeners.delete(fn);}
export function configureSoundAccount(id){
  const next=id==null?null:Number(id);if(accountId===next)return;
  accountId=next;initialized=false;latestIncoming=0;error=false;
  try{enabled=next!=null&&localStorage.getItem(key(next))==='on';}catch(_){enabled=false;}
  emit();
}
function loadBuffer(){
  if(buffer)return Promise.resolve(buffer);
  if(!loading){
    loading=fetch('/sounds/aeonas-chat-msn.wav').then(r=>{if(!r.ok)throw new Error('Sound unavailable');return r.arrayBuffer();})
      .then(data=>context.decodeAudioData(data)).then(b=>{buffer=b;return b;}).catch(e=>{loading=null;throw e;});
  }
  return loading;
}
async function unlock(){
  const AudioContext=window.AudioContext||window.webkitAudioContext;
  if(!AudioContext)throw new Error('Audio unavailable');
  if(!context){context=new AudioContext();context.addEventListener('statechange',emit);}
  // resume() is called during the user's click, before any fetch await.
  const resumed=context.resume();
  await resumed;await loadBuffer();
  if(context.state!=='running')throw new Error('Audio blocked');
  emit();
}
function playTone(){
  if(!enabled||document.visibilityState!=='visible'||!buffer||context?.state!=='running')return false;
  const source=context.createBufferSource();source.buffer=buffer;
  const gain=context.createGain();gain.gain.value=.85;
  source.connect(gain);gain.connect(context.destination);
  source.onended=()=>{source.disconnect();gain.disconnect();};source.start();return true;
}
export async function enableSound(){
  if(accountId==null||busy)return false;
  const user=accountId;busy=true;error=false;emit();
  try{
    await unlock();if(accountId!==user)return false;
    enabled=true;try{localStorage.setItem(key(user),'on');}catch(_){}
    playTone();return true;
  }catch(_){if(accountId===user)error=true;return false;}
  finally{busy=false;emit();}
}
export function disableSound(){
  enabled=false;error=false;
  try{if(accountId!=null)localStorage.setItem(key(accountId),'off');}catch(_){}
  emit();
}
export function observeIncoming(userId,incoming={}){
  if(Number(userId)!==accountId)return;
  const max=Math.max(0,...Object.values(incoming).map(n=>Number(n)||0));
  if(!initialized){initialized=true;latestIncoming=max;return;}
  if(max<=latestIncoming)return;
  latestIncoming=max;
  playTone();
}
// Remember the preference, but unlock sound only through a real interaction.
if(typeof document!=='undefined'){
  const gesture=()=>{
    if(accountId!=null&&enabled&&context?.state!=='running'&&!busy){
      busy=true;void unlock().catch(()=>{error=true;}).finally(()=>{busy=false;emit();});
    }
  };
  document.addEventListener('click',gesture);
  document.addEventListener('keydown',gesture);
}
